import { FC } from "react";
import {
	Dialog,
	DialogContent,
	DialogClose,
	DialogTitle
} from "src/components/ui/dialog";
import { Button } from "src/components/ui/button";
import { X } from "lucide-react";
import ObservationFormsCarousel from "src/containers/ObservationFormsCarousel/ObservationFormsCarousel";
import isEmpty from "lodash.isempty";

export interface ReportAnswerModalProps {
	isOpen: boolean;
	onClose: () => void;
	observations: number[];
	form?: Partial<IObservationForm>;
	onExportAllObservationsClick?: () => void;
	showGradingReportState?: boolean;
}

const ReportAnswerModal: FC<ReportAnswerModalProps> = ({
	observations,
	form,
	onExportAllObservationsClick,
	showGradingReportState,
	isOpen,
	onClose
}) => {
	return (
		<Dialog
			open={isOpen}
			onOpenChange={(open) => {
				if (!open) onClose();
			}}
		>
			<DialogContent className="p-0 w-[90%] max-w-[900px] overflow-y-auto overflow-x-hidden max-h-[85vh] rounded-xl [&>button:last-child]:hidden">
				<DialogTitle className="sr-only">Report answers</DialogTitle>
				<div className="flex justify-end px-3 pt-3">
					<DialogClose className="flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-md border border-border transition-colors hover:bg-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-ring">
						<X className="h-4 w-4 text-foreground" />
						<span className="sr-only">Close</span>
					</DialogClose>
				</div>
				<div className="px-6 pb-6">
					{!isEmpty(observations) && (
						<div>
							<ObservationFormsCarousel
								observations={observations}
								showInstanceSummary={true}
								handlecloseReportAnswerModalClick={onClose}
								form={form}
								showGradingReportState={showGradingReportState}
							/>
						</div>
					)}

					<hr className="border-border mt-8 mb-6" />

					<div className="flex flex-col sm:flex-row sm:justify-between gap-3">
						{onExportAllObservationsClick && (
							<Button
								variant="outline"
								size="lg"
								onClick={onExportAllObservationsClick}
							>
								Export all observations
							</Button>
						)}

						<Button size="lg" onClick={onClose}>
							Close
						</Button>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default ReportAnswerModal;
